import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useMain } from '../../Hook/Main'
import Spinner from '../../Components/Spinner'
function Index() {
    const { data, setData, Request } = useMain()
    const { saved } = data;
    const [loading, setloading] = useState(false)
    const Delete = (id, name = null) => {
        let newSaved = saved ? saved : [];
        if (name) {
            newSaved = [...newSaved].filter((sav) => sav.filter.name != name)
            setData('saved', newSaved, 'data');
            return;
        }
        if (id) {
            setloading(id)
            Request({
                url: "/delete-save", props: { id: id }, callback: (response) => {
                    setloading(false)
                    if (response) {
                        newSaved = [...newSaved].filter((sav) => sav.id != id)
                        setData('saved', newSaved, 'data');
                    }
                }
            })
        }
    }
    useEffect(() => {

        Request({
            url: "/saved",
            key: "saved"
        })

    }, [])




    const Item = ({ item }) => {
        const { filter, id } = item;

        return (
            <div className="saved-main d-flex justify-content-between p-4">
                <div className="Contents-main">
                    <Link to={'/ProductList'}>
                        <h6>{filter.name}</h6>
                    </Link>
                </div>
                <span onClick={() => {
                    if (id) {
                        Delete(id)
                    } else {
                        Delete(null, filter.name)
                    }
                }}>{loading === id ? <Spinner sm /> : <i class="far fa-trash"></i>}</span>
            </div>
        )
    }
    const Content = () => {
        return (
            saved && saved.length ? saved.map((item, i) => {
                return <Item item={item} key={i} />
            }) : <p className='text-center'>موردی ثبت نشده</p>
        )
    }
    return (
        <Layout>
            <HeaderMain lable="جستجو های ذخیره شده" />
            <div className="all-saved">
                <Content />
            </div>
        </Layout>
    )
}

export default Index